import type { FC, ReactNode } from 'react';
import clsx from 'clsx';

export interface AttachmentToastProps {
  title: string;
  description: string | ReactNode;
}

const descriptionClasses = clsx('text-info-500 mt-2 text-sm leading-5 font-normal');
const titleClasses = clsx('text-info-900 mt-[3px] leading-5 font-medium');
const containerClasses = clsx('flex flex-col gap-1 max-w-[280px]');

export const AttachmentToast: FC<AttachmentToastProps> = ({ description, title }) => {
  return (
    <div className={containerClasses}>
      <p className={titleClasses}>{title}</p>
      <p className={descriptionClasses}>{description}</p>
    </div>
  );
};
